import { localisedValue } from "utils"

const inquiryStatusTransformer = data => {
  let inquiryObject = {}

  data?.forEach(item => {
    const localizedOptions = item?.ExternalInquiryStatusChangeReasons?.map(reason => ({
      ...reason,
      title: localisedValue({ object: reason, key: "title" }),
    }))

    inquiryObject[item.key] = {
      options: localizedOptions,
    }
  })

  const inquiryOptions = data.map(e => {
    return {
      ...e,
      id: e.id,
      label: localisedValue({ object: e, key: "title" }),
      value: e.id.toString(),
    }
  })

  return { inquiryOptions, inquiryObject }
}

export default inquiryStatusTransformer
